import { IconArrowRight, IconArrowLeft } from '@tabler/icons-react'

export default function StepperNavigationButtons(props) {
    // console.log("props", props);
    // console.log("props.save", props.save); // Check if the function is being passed
        return (<>
        <div className="row mt-4 pe-0">
            <div className="col-12 d-flex justify-content-between pe-0">
                {props.index > 0 ? (
                    <button
                        onClick={(e) => props.navigate(e, props.index - 1)}
                        className="btn btn-primary btn-prev">
                        <IconArrowLeft className="me-sm-1 me-0" size={20} />
                        <span className="align-middle d-sm-inline-block d-none">
                            Previous
                        </span>
                    </button>
                ) : (
                    <div></div>
                )}
                {props.index < props.steps - 1 ? (
                    <button
                        onClick={(e) => props.navigate(e, props.index + 1)}
                        className="btn btn-primary btn-next">
                        <span className="align-middle d-sm-inline-block d-none me-sm-1">
                            Next
                        </span>
                        <IconArrowRight size={20} />
                    </button>
                ) : (<></>)}
                {props.index >= props.steps - 1 ? (
                    <button
                    onClick={(e) => props.save(e)} // Uncomment this line
                    className="btn btn-primary btn-next">
                    <span className="align-middle d-sm-inline-block d-none me-sm-1">
                        Save & Preview
                    </span>
                    <IconArrowRight size={20} />
                </button>
                
                ) : (<></>)}
            </div>
        </div >
    </>);
}